up.compiler('[data-video-timestamp]', (videoTimestamp: HTMLElement) => {
  const timestamp = parseInt(videoTimestamp.getAttribute('timestamp')!)
  let linkedVideoPath = videoTimestamp.getAttribute('href')

  videoTimestamp.addEventListener('click', (event: MouseEvent) => {
    event.preventDefault()
    if (!linkedVideoPath) {
      const videoTimestampTarget = videoTimestamp.closest('[data-video-timestamp--default-target]')
      const defaultTarget = videoTimestampTarget
        ? videoTimestampTarget.getAttribute('data-video-timestamp--default-target')
        : null
      if (defaultTarget) {
        if (defaultTarget.indexOf('?') === -1) {
          linkedVideoPath = `${defaultTarget}?t=${timestamp}`
        } else {
          linkedVideoPath = `${defaultTarget}&t=${timestamp}`
        }
      }
    }

    if (linkedVideoPath) {
      up.visit(linkedVideoPath, { scroll: 'target' })
    } else {
      up.emit('player:switch:video')
      up.emit('timestamp:seek', { element: videoTimestamp, timestamp })
    }
  })
})
